import React from "react";

export const GridBg = ({ children, hero = false, className = "" }) => (
  <div className={`relative overflow-hidden ${className}`}>
    <div className="absolute inset-0 grid-bg radial-fade pointer-events-none" />
    {hero && (
      <>
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full"
             style={{ background: "radial-gradient(closest-side, rgba(59,130,246,0.25), transparent)" }}/>
        <div className="absolute -bottom-40 -left-40 w-[600px] h-[600px] rounded-full"
             style={{ background: "radial-gradient(closest-side, rgba(37,99,235,0.18), transparent)" }}/>
      </>
    )}
    <div className="relative">{children}</div>
  </div>
);

export default GridBg;
